import { Suspense } from 'react';
import ProductConfiguration from 'components/pages/product/product_configuration';
import PageLoader from 'components/common/page_loader';
import ShopTheme from 'theme/shop_theme';
// eslint-disable-next-line import/no-unassigned-import
import 'utilities/i18n';
import { FeatureFlags } from 'components/context/feature_flags';
import { datadogRum } from '@datadog/browser-rum';
import CustomQueryClientProvider from 'typescript/providers/custom_query_client_provider';

const ProductApp = (props) => {
  // Set additional global context for Datadog RUM
  datadogRum.setGlobalContext(props.rumAttributes || {});

  return (
    <ShopTheme>
      <Suspense fallback={<PageLoader delayMs={500} />}>
        <CustomQueryClientProvider>
          <FeatureFlags {...props}>
            <ProductConfiguration {...props} />
          </FeatureFlags>
        </CustomQueryClientProvider>
      </Suspense>
    </ShopTheme>
  );
};

export default ProductApp;
